import { SeatPickerScreenPosition } from '../types/config/screen-position';
/**
 * Returns the scale factor (scale factor * % = dimension) of a seat layout map based on the minimum seat size.
 */
export function getMapScaleFactor(seatLayout, config) {
    const areaSeatSizeRatios = seatLayout.areas.map(getMinimumAreaSeatSizeRatio);
    const minSeatSizeRatio = Math.min(...areaSeatSizeRatios);
    return (config.seats.minimumSize + config.seats.margin * 2) / minSeatSizeRatio;
}
/**
 * Converts a seat layout percentage to a SVG unit using a scale factor.
 */
export function getMapDimension(percentage, scaleFactor) {
    return Math.ceil(percentage * scaleFactor);
}
/**
 * Returns the minimum seat size ratio of an area as a percentage (e.g. area.width of 50% / 10 seats = ratio of 5% per seat).
 */
export function getMinimumAreaSeatSizeRatio(area) {
    const width = area.boundary.right - area.boundary.left;
    const height = area.boundary.bottom - area.boundary.top;
    const widthRatio = width / area.columnCount;
    const heightRatio = height / area.rowCount;
    return Math.min(widthRatio, heightRatio);
}
/**
 * Returns the SVG rectangle of the seat map.
 */
export function getMapRectangle(scaleFactor, boundary, screenConfig, rowLabelsConfig) {
    const width = boundary.right - boundary.left;
    const height = 100 - boundary.top;
    return Object.assign(Object.assign({}, getMapCoordinates(boundary, screenConfig.position)), { width: getMapDimension(width, scaleFactor) + rowLabelsConfig.size + rowLabelsConfig.margin * 2, height: getMapDimension(height, scaleFactor) + screenConfig.height + screenConfig.margin });
}
function getMapCoordinates(boundary, screenPosition) {
    return screenPosition === SeatPickerScreenPosition.Bottom
        ? {
            y: boundary.top,
            x: boundary.left
        }
        : {
            y: 0,
            x: 100 - boundary.right
        };
}
